var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNivel4Completo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 85,
    viewBox: "0 0 61 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.316 30.158C60.316 46.8095 46.818 60.316 30.158 60.316C13.498 60.316 0 46.8095 0 30.158C0 13.5065 13.5065 0 30.158 0C46.8095 0 60.316 13.498 60.316 30.1495V30.158Z",
    fill: "url(#paint0_linear_1685_4513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4893 44.1255C48.4893 54.249 30.1548 84.288 30.1548 84.288C30.1548 84.288 11.8203 54.2575 11.8203 44.1255C11.8203 33.9935 20.0313 25.791 30.1548 25.791C40.2783 25.791 48.4893 34.002 48.4893 44.1255Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4893 36.0611C48.4893 46.1846 30.1548 76.2236 30.1548 76.2236C30.1548 76.2236 11.8203 46.1931 11.8203 36.0611C11.8203 25.9291 20.0313 17.7266 30.1548 17.7266C40.2783 17.7266 48.4893 25.9376 48.4893 36.0611Z",
    fill: "url(#paint1_linear_1685_4513)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2157 30.1606C56.2157 44.5511 44.5452 56.2216 30.1547 56.2216C15.7642 56.2216 4.09375 44.5511 4.09375 30.1606C4.09375 15.7701 15.7642 4.09961 30.1547 4.09961C44.5452 4.09961 56.2157 15.7701 56.2157 30.1606Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2515 38.2839C22.0819 38.2839 21.0347 37.9983 20.1099 37.4271C19.1851 36.8423 18.4575 35.9991 17.9271 34.8975C17.3967 33.7959 17.1315 32.4631 17.1315 30.8991C17.1315 29.3351 17.3967 28.0023 17.9271 26.9007C18.4575 25.7991 19.1851 24.9627 20.1099 24.3915C21.0347 23.8067 22.0819 23.5143 23.2515 23.5143C24.4347 23.5143 25.4819 23.8067 26.3931 24.3915C27.3179 24.9627 28.0455 25.7991 28.5759 26.9007C29.1063 28.0023 29.3715 29.3351 29.3715 30.8991C29.3715 32.4631 29.1063 33.7959 28.5759 34.8975C28.0455 35.9991 27.3179 36.8423 26.3931 37.4271C25.4819 37.9983 24.4347 38.2839 23.2515 38.2839ZM23.2515 35.4891C23.8091 35.4891 24.2919 35.3327 24.6999 35.0199C25.1215 34.7071 25.4479 34.2107 25.6791 33.5307C25.9239 32.8507 26.0463 31.9735 26.0463 30.8991C26.0463 29.8247 25.9239 28.9475 25.6791 28.2675C25.4479 27.5875 25.1215 27.0911 24.6999 26.7783C24.2919 26.4655 23.8091 26.3091 23.2515 26.3091C22.7075 26.3091 22.2247 26.4655 21.8031 26.7783C21.3951 27.0911 21.0687 27.5875 20.8239 28.2675C20.5927 28.9475 20.4771 29.8247 20.4771 30.8991C20.4771 31.9735 20.5927 32.8507 20.8239 33.5307C21.0687 34.2107 21.3951 34.7071 21.8031 35.0199C22.2247 35.3327 22.7075 35.4891 23.2515 35.4891ZM30.814 35.0403V32.8167L37.546 23.7591H41.014L34.4248 32.8167L32.8132 32.3475H44.0536V35.0403H30.814ZM38.5048 38.0391V35.0403L38.6068 32.3475V29.6751H41.728V38.0391H38.5048Z",
    fill: "#00804E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1685_4513",
    x1: 8.8315,
    y1: 51.4845,
    x2: 51.4845,
    y2: 8.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00804E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1685_4513",
    x1: 13.6308,
    y1: 59.6996,
    x2: 46.6788,
    y2: 26.6601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#00804E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivel4Completo);
export default __webpack_public_path__ + "static/media/Nivel4Completo.d99bf48bc0b97c2940195ab041cad749.svg";
export { ForwardRef as ReactComponent };